import api from './api';

const generatedDocService = {
    // Generate documents from template set
    generateDocument: async (templateSetId,officeSpaceId = null, values, title = null, metadata = null) => {
        const response = await api.post('/api/generated-docs/generate', {
            templateSetId,
            officeSpaceId,
            values,
            title,
            metadata
        });
        return response;
    },

    // Get all generated document groups
    getGeneratedDocs: async (params = {}) => {
        const response = await api.get('/api/generated-docs', { params });
        return response;
    },

    // Get single document group by ID
    getDocSetById: async (setId) => {
        const response = await api.get(`/api/generated-docs/${setId}`);
        return response;
    },

    // Regenerate documents from existing group with new values
    regenerateDoc: async (setId, values, title = null, metadata = null) => {
        const response = await api.post(`/api/generated-docs/${setId}/regenerate`, {
            values,
            title,
            metadata
        });
        return response;
    },

    // Update generated document content
    updateDocument: async (docId, content) => {
        const response = await api.put(`/api/generated-docs/document/${docId}`, {
            content
        });
        return response;
    },

    // Delete document group
    deleteDocSet: async (setId) => {
        const response = await api.delete(`/api/generated-docs/${setId}`);
        return response;
    },

    // Get statistics
    getStats: async () => {
        const response = await api.get('/api/generated-docs/stats');
        return response;
    },

    // Get recently used template sets
    getRecentlyUsedTemplates: async (limit = 6) => {
        const response = await api.get('/api/generated-docs/recent-templates', {
            params: { limit }
        });
        return response;
    },

    // Update generated document content
    updateGeneratedDoc: async (docId, content, { isManuallyEdited = false } = {}) => {
        const response = await api.patch(`/api/generated-docs/editor/${docId}`, {
            content,
            isManuallyEdited,
        });
        return response;
    },

    // Upload a generated PDF blob to R2 and store the URL on the GeneratedDoc record
    uploadDocPdf: async (docId, pdfBlob) => {
        const formData = new FormData();
        formData.append('file', pdfBlob, `doc-${docId}.pdf`);
        const response = await api.post(`/api/generated-docs/document/${docId}/upload-pdf`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return response;
    },
};

export default generatedDocService;
